<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<h2 mat-dialog-title>Restore Backup</h2>
<p class="subtitle">{{ data.subTitle }}</p>
<mat-dialog-content>
  @if (step() === 0) {
    <div class="info row">
      <div class="column">
        <span>Backup date</span>
        <span>{{ data.createdAt }}</span>
      </div>
      <div class="column">
        <span>Server</span>
        <span>{{ data.server }}</span>
      </div>
    </div>
    <form [formGroup]="form">
      <div class="presets">
        <mat-radio-group [(ngModel)]="preset" [ngModelOptions]="{ standalone: true }">
          @for (item of PRESETS; track item.value) {
            <div
              class="preset"
              [class.preset-selected]="preset() === item.value"
              (click)="preset.set(item.value)"
            >
              <mat-radio-button [value]="item.value" (click)="$event.stopPropagation()">{{
                item.title
              }}</mat-radio-button>
              <div class="hint">{{ item.hint }}</div>
            </div>
          }
        </mat-radio-group>
      </div>

      @if (preset() === 1) {
        <mat-accordion togglePosition="before">
          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title>Select what to restore</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row sb">
              <h5>Config</h5>
              @if (preset() === 1) {
                <button matButton="text" (click)="featuresToggle()">
                  {{ isAllFeatureSelected ? 'Deselect All' : 'Select All' }}
                </button>
              }
            </div>
            <div class="checkboxes grid">
              @for (option of FEATURES; track option.value) {
                <mat-checkbox
                  [checked]="selectedFeatures.value.includes(option.value)"
                  (change)="onFeaturesChange(option.value, $event.checked)"
                  [disabled]="disableFeatures()"
                >
                  {{ option.label }}
                </mat-checkbox>
              }
            </div>
            <h3>Snapshots: Files, Databases and Mailboxes</h3>
            <div class="column">
              <mat-checkbox
                [checked]="selectedTargets.value.includes(rootDir.value)"
                (change)="onTargetsChange(rootDir.value, $event.checked)"
                [disabled]="disableTargets()"
              >
                Root directory: {{ rootDir.label }}
              </mat-checkbox>
              @if (databases.length > 0) {
                <mat-checkbox
                  [checked]="isAllDatabasesSelected"
                  (change)="toggleAllDatabases($event.checked)"
                  [disabled]="disableTargets()"
                >
                  Databases:
                </mat-checkbox>
              }
              <div class="indent">
                @for (database of databases; track database.value) {
                  <mat-checkbox
                    [checked]="selectedTargets.value.includes(database.value)"
                    (change)="onTargetsChange(database.value, $event.checked)"
                    [disabled]="disableTargets()"
                  >
                    {{ database.label }}
                  </mat-checkbox>
                }
              </div>
              @if (mailboxes.length > 0) {
                <mat-checkbox
                  [checked]="isAllMailboxesSelected"
                  (change)="toggleAllMailboxes($event.checked)"
                  [disabled]="disableTargets()"
                >
                  Mailboxes:
                </mat-checkbox>
              }
              <div class="indent">
                @for (mailbox of mailboxes; track mailbox.value) {
                  <mat-checkbox
                    [checked]="selectedTargets.value.includes(mailbox.value)"
                    (change)="onTargetsChange(mailbox.value, $event.checked)"
                    [disabled]="disableTargets()"
                  >
                    {{ mailbox.label }}
                  </mat-checkbox>
                }
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      }
    </form>
  } @else {
    <div class="preview column">
      @if (displayFeatures.length > 0) {
        <mat-accordion togglePosition="before">
          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title>Config</mat-panel-title>
            </mat-expansion-panel-header>

            <div class="grid">
              @for (feature of displayFeatures; track feature) {
                <span>{{ feature }}</span>
              }
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      }

      @if (isSnapshotsToRestore) {
        <mat-accordion togglePosition="before">
          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title>Snapshots: Files, Databases and Mailboxes</mat-panel-title>
            </mat-expansion-panel-header>

            <div class="snapshots column">
              @if (selectedTargets.value.includes(rootDir.value)) {
                <div class="column">
                  <b>Files</b>
                  <span>Root directory: {{ rootDir.label }}</span>
                </div>
              }
              @if (displayDatabases.length > 0) {
                <div class="column">
                  <b>Databases</b>
                  <ul>
                    @for (database of displayDatabases; track database) {
                      <li>{{ database }}</li>
                    }
                  </ul>
                </div>
              }
              @if (displayMailboxes.length > 0) {
                <div class="column">
                  <b>Mailboxes</b>
                  <ul>
                    @for (mailbox of displayMailboxes; track mailbox) {
                      <li>{{ mailbox }}</li>
                    }
                  </ul>
                </div>
              }
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      }
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" (click)="submit()">
    <fa-icon [icon]="submitButton().icon" size="lg"></fa-icon>
    {{ submitButton().text }}
  </button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
